export default __webpack_public_path__ + "images/461196aadaca83bcfd56a1970893db20.png";